import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Magyar",
  code: "hu",
  messages: {
    alert: {
      close: "Bez\xE1r\xE1s"
    },
    authForm: {
      hidePassword: "Jelsz\xF3 elrejt\xE9se",
      showPassword: "Jelsz\xF3 megjelen\xEDt\xE9se",
      submit: "Folytat\xE1s"
    },
    banner: {
      close: "Bez\xE1r\xE1s"
    },
    calendar: {
      nextMonth: "K\xF6vetkez\u0151 h\xF3nap",
      nextYear: "K\xF6vetkez\u0151 \xE9v",
      prevMonth: "El\u0151z\u0151 h\xF3nap",
      prevYear: "El\u0151z\u0151 \xE9v"
    },
    carousel: {
      dots: "V\xE1lassza ki a megjelen\xEDtend\u0151 di\xE1t",
      goto: "Ugr\xE1s ide {slide}",
      next: "K\xF6vetkez\u0151",
      prev: "El\u0151z\u0151"
    },
    chatPrompt: {
      placeholder: "\xCDrd be a k\xE9rd\xE9sedet itt..."
    },
    chatPromptSubmit: {
      label: "K\xFCld\xE9s"
    },
    colorMode: {
      dark: "S\xF6t\xE9t",
      light: "Vil\xE1gos",
      switchToDark: "V\xE1lt\xE1s s\xF6t\xE9t m\xF3dra",
      switchToLight: "V\xE1lt\xE1s vil\xE1gos m\xF3dra",
      system: "Rendszer"
    },
    commandPalette: {
      back: "Vissza",
      close: "Bez\xE1r\xE1s",
      noData: "Nincs adat",
      noMatch: "Nincs tal\xE1lat",
      placeholder: "\xCDrjon be egy parancsot vagy keressen..."
    },
    contentSearch: {
      links: "Linkek",
      theme: "T\xE9ma"
    },
    contentSearchButton: {
      label: "Keres\xE9s..."
    },
    contentToc: {
      title: "Ezen az oldalon"
    },
    dashboardSearch: {
      theme: "T\xE9ma"
    },
    dashboardSearchButton: {
      label: "Keres\xE9s..."
    },
    dashboardSidebarCollapse: {
      collapse: "Oldals\xE1v \xF6sszecsuk\xE1sa",
      expand: "Oldals\xE1v kinyit\xE1sa"
    },
    dashboardSidebarToggle: {
      close: "Oldals\xE1v bez\xE1r\xE1sa",
      open: "Oldals\xE1v megnyit\xE1sa"
    },
    error: {
      clear: "Vissza a f\u0151oldalra"
    },
    fileUpload: {
      removeFile: "{filename} elt\xE1vol\xEDt\xE1sa"
    },
    header: {
      close: "Men\xFC bez\xE1r\xE1sa",
      open: "Men\xFC megnyit\xE1sa"
    },
    inputMenu: {
      create: '"{label}" l\xE9trehoz\xE1sa',
      noData: "Nincs adat",
      noMatch: "Nincs tal\xE1lat"
    },
    inputNumber: {
      decrement: "Cs\xF6kkent",
      increment: "N\xF6vel"
    },
    modal: {
      close: "Bez\xE1r\xE1s"
    },
    pricingTable: {
      caption: "\xC1rlista \xF6sszehasonl\xEDt\xE1sa"
    },
    prose: {
      codeCollapse: {
        closeText: "\xD6sszecsuk",
        name: "k\xF3d",
        openText: "Kinyit"
      },
      collapsible: {
        closeText: "Elrejt",
        name: "tulajdons\xE1gok",
        openText: "Mutat"
      },
      pre: {
        copy: "K\xF3d m\xE1sol\xE1sa a v\xE1g\xF3lapra"
      }
    },
    selectMenu: {
      create: '"{label}" l\xE9trehoz\xE1sa',
      noData: "Nincs adat",
      noMatch: "Nincs tal\xE1lat",
      search: "Keres\xE9s..."
    },
    slideover: {
      close: "Bez\xE1r\xE1s"
    },
    table: {
      noData: "Nincs adat"
    },
    toast: {
      close: "Bez\xE1r\xE1s"
    }
  }
});
